"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentUrl = void 0;
const complex_utils_1 = require("complex-utils");
const setting_1 = __importDefault(require("../setting"));
const getCurrentUrl = function (type, real) {
    const realEnv = (0, complex_utils_1.getEnv)('real');
    const prop = (0, complex_utils_1.getEnvMode)('data') || 'default';
    let currentUrl;
    if (setting_1.default.proxy.run && realEnv === 'development' && !real) {
        currentUrl = setting_1.default.proxy.buildProp(type, prop) + '/';
    }
    else {
        currentUrl = setting_1.default.proxy.url[type][prop];
        if (!currentUrl) {
            currentUrl = setting_1.default.proxy.url[type].default;
        }
    }
    return currentUrl;
};
exports.getCurrentUrl = getCurrentUrl;
